import { useData } from "./DataContext.js";
import { useState, useEffect } from "react";

import Alert from "react-bootstrap/Alert";


export default function MyAlert (props)
{
    const gData = useData();

    let alertTimeout = 15000;
    let alertWidth = 300;

    if (gData.content.params !== undefined)
    {
	if (gData.content.params.alertTimeout !== undefined) alertTimeout = gData.content.params.alertTimeout;
	if (gData.content.params.alertWidth !== undefined) alertWidth = gData.content.params.alertWidth;
    }
    
    const [show, setShow] = useState(true);
    function handleClose () { setShow(false); }

    useEffect(() => { setTimeout(() => { handleClose() }, alertTimeout); }, [alertTimeout]);
    
    return (
	<Alert show={show} variant={props.variant} className="shadow" style={{ width: alertWidth }} dismissible onClose={handleClose}>
	    {props.title !== undefined && (<Alert.Heading className="fs-5 m-0">{props.title}</Alert.Heading>)}
	    {props.content !== undefined && (<div className="mt-2">{props.content}</div>)}
	</Alert>
    );
}
